export const toolkitColors = [
  "Almond",
  "Barley",
  "Kelp",
  "Lilac",
  "Mink",
  "Oat",
  "Olive",
  "Sage",
  "Silk",
  "Tofu",
];
